import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSession } from 'components/Providers'
import { CloseIcon, EditIcon } from 'components/Icons'

export default function DashboardWelcome({ editing, onToggle, canCustomize }) {
  const { t } = useTranslation()
  const { person, school, academicYear } = useSession()

  const subtitle = [school?.name, academicYear?.name].filter(Boolean).join(' · ')

  return (
    <Paper variant="outlined" sx={{ p: 2.5, mb: 1, borderRadius: 1 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h6" sx={{ fontWeight: 500 }} noWrap>
            {`${t('Welcome back')}, ${person?.firstName ?? ''}`}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" noWrap>
              {subtitle}
            </Typography>
          )}
        </Box>

        {canCustomize && (
          <Button
            size="small"
            variant={editing ? 'contained' : 'outlined'}
            startIcon={editing ? <CloseIcon /> : <EditIcon />}
            onClick={onToggle}
            sx={{ flexShrink: 0 }}
          >
            {editing ? t('Done') : t('Customize')}
          </Button>
        )}
      </Stack>
    </Paper>
  )
}
